// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function exhaustiveCheck(_: never) {}
